import logo from '../assets/img/logo.png';

export const images = [
    logo,
];
